var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.$t("label_essweb_attendanceModifiApp_form_viewTitle"),
      backgroundClass: "transparent",
      widthClass: "max-1000",
      pad: "0",
    },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            !_vm.Data ? _c("noContent") : _vm._e(),
            _vm.Data
              ? _c("ApprovalTriger", {
                  attrs: {
                    "bg-color": _vm.Data.approval_bg_color,
                    "slide-color": _vm.Data.approval_tint_color,
                  },
                  on: {
                    triger: function ($event) {
                      return _vm.$toPage(
                        "/admin/attendance-modification/detail/" +
                          _vm.$route.params.params +
                          "/approval-detail/" +
                          _vm.$route.params.params
                      )
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "time",
                        fn: function () {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$getDateTime(
                                    _vm.Data.operate_utc_datetime,
                                    "YYYY/MM/DD HH:mm"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "status",
                        fn: function () {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$getCommonLangValue(
                                    _vm.Data.status_detail
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    2072884572
                  ),
                })
              : _vm._e(),
            _vm.Data
              ? _c(
                  "Section",
                  [
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "6",
                              md: "6",
                              lg: "6",
                              cols: "12",
                            },
                          },
                          [
                            _c("v-sheet", { staticClass: "text--secondary" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "label_essweb_attendanceModifiApp_form_swiftNumberLabel"
                                  )
                                )
                              ),
                            ]),
                            _c("v-text-field", {
                              attrs: {
                                readonly: "",
                                label: _vm.$t(
                                  "label_essweb_attendanceModifiApp_form_swiftNumberLabel"
                                ),
                                "single-line": "",
                                dense: "",
                              },
                              model: {
                                value: _vm.Data.swift_number,
                                callback: function ($$v) {
                                  _vm.$set(_vm.Data, "swift_number", $$v)
                                },
                                expression: "Data.swift_number",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "6",
                              md: "6",
                              lg: "6",
                              cols: "12",
                            },
                          },
                          [
                            _c("v-sheet", { staticClass: "text--secondary" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "label_essweb_attendanceModifiApp_form_appliedOnLabel"
                                  )
                                )
                              ),
                            ]),
                            _c("v-text-field", {
                              attrs: {
                                readonly: "",
                                value: _vm.$getDateTime(
                                  _vm.Data.submission_utc_datetime,
                                  "YYYY/MM/DD HH:mm"
                                ),
                                label: _vm.$t(
                                  "label_essweb_attendanceModifiApp_form_appliedOnLabel"
                                ),
                                "single-line": "",
                                dense: "",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "6",
                              md: "6",
                              lg: "6",
                              cols: "12",
                            },
                          },
                          [
                            _c("AutoComplete", {
                              attrs: {
                                label:
                                  "label_essweb_attendanceModifiApp_form_applicantLabel",
                                readonly: "",
                                chips: "",
                                "small-chips": "",
                                avatar: "",
                                "two-line": "",
                                items: _vm.users,
                                "item-value": "uuid",
                                "item-text": "preferred_name",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "selection.avatar",
                                    fn: function (ref) {
                                      var data = ref.data
                                      return [
                                        _c("StaffAvatar", {
                                          attrs: {
                                            src: data.item.staff_avatar,
                                            left: "",
                                            small: "",
                                            isTemp: data.item.is_temp,
                                            staff_name:
                                              data.item.preferred_name,
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: "selection",
                                    fn: function (ref) {
                                      var data = ref.data
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$getCommonLangValue(
                                                data.item.preferred_name
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3219670475
                              ),
                              model: {
                                value: _vm.user,
                                callback: function ($$v) {
                                  _vm.user = $$v
                                },
                                expression: "user",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "6",
                              md: "6",
                              lg: "6",
                              cols: "12",
                            },
                          },
                          [
                            _c("AutoComplete", {
                              attrs: {
                                label:
                                  "label_essweb_attendanceModifiApp_form_appliedByLabel",
                                readonly: "",
                                chips: "",
                                avatar: "",
                                "small-chips": "",
                                "two-line": "",
                                items: _vm.users2,
                                "item-value": "uuid",
                                "item-text": "preferred_name",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "selection.avatar",
                                    fn: function (ref) {
                                      var data = ref.data
                                      return [
                                        _c("StaffAvatar", {
                                          attrs: {
                                            src: data.item.staff_avatar,
                                            left: "",
                                            small: "",
                                            isTemp: data.item.is_temp,
                                            staff_name:
                                              data.item.preferred_name,
                                          },
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: "selection",
                                    fn: function (ref) {
                                      var data = ref.data
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$getCommonLangValue(
                                                data.item.preferred_name
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3219670475
                              ),
                              model: {
                                value: _vm.user2,
                                callback: function ($$v) {
                                  _vm.user2 = $$v
                                },
                                expression: "user2",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.Data
              ? _c(
                  "v-card",
                  { staticClass: "pa-0 my-8 elevation-0 rounded-lg" },
                  [
                    _c(
                      "v-card-text",
                      {
                        staticClass:
                          "pa-0 rounded-lg mrc_map scroll_content_no fill-height",
                        style: {
                          background: "url(" + _vm.mapbg + ")",
                          minHeight:
                            _vm.$vuetify.breakpoint.height -
                            56 -
                            78 -
                            72 -
                            72 +
                            "px",
                        },
                      },
                      [
                        !_vm.showMap
                          ? _c(
                              "v-sheet",
                              {
                                staticClass:
                                  "panel_btn text-center transparent",
                                on: {
                                  click: function ($event) {
                                    _vm.showMap = true
                                  },
                                },
                              },
                              [
                                _c("svg-icon", {
                                  attrs: {
                                    size: "72",
                                    fill: "grey",
                                    iconClass: "NoMap",
                                  },
                                }),
                                _c("div", { staticClass: "primary--text" }, [
                                  _vm._v("View Map"),
                                ]),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "v-container",
                          {
                            staticClass:
                              "\n            transparent\n            panel_left\n            d-flex\n            justify-start\n            flex-row\n            pa-0\n            fill-height\n            ma-0\n          ",
                            style: { width: _vm.leftWidth + 30 + "px" },
                          },
                          [
                            _c(
                              "v-sheet",
                              {
                                staticClass:
                                  "rounded-l-lg ma-0 scroll_content_y",
                                class: _vm.leftWidth == 0 ? "pa-0" : "pa-4",
                                staticStyle: { "overflow-x": "hidden" },
                                attrs: {
                                  height: "100%",
                                  width: _vm.leftWidth,
                                  color: "rgba(0,0,0,0.38)",
                                },
                              },
                              [
                                _c(
                                  "v-sheet",
                                  {
                                    staticClass: "rounded-xl px-2",
                                    attrs: { elevation: "1" },
                                  },
                                  [
                                    _c(
                                      "v-list-item",
                                      {
                                        staticClass: "pa-0 ma-0",
                                        attrs: { dense: "", "two-line": "" },
                                      },
                                      [
                                        _c(
                                          "v-list-item-avatar",
                                          {
                                            staticClass: "mr-1 my-0 pa-0",
                                            attrs: { size: "36" },
                                          },
                                          [
                                            _c("StaffAvatar", {
                                              attrs: {
                                                isTemp: _vm.Data.is_temp,
                                                size: "36",
                                                src: _vm.Data.staff_avatar,
                                                staff_name:
                                                  _vm.Data.preferred_name,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-list-item-content",
                                          [
                                            _c(
                                              "v-list-item-title",
                                              { staticClass: "text-body-2" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$getCommonLangValue(
                                                        _vm.Data.preferred_name
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "text--secondary text-caption-xs",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.Data.staff_code
                                                        )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "v-list-item-subtitle",
                                              { staticClass: "text-body-2" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$getCommonLangValue(
                                                        _vm.Data.job_post_name
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-sheet",
                                  {
                                    staticClass:
                                      "\n                transparent\n                d-flex\n                flex-row\n                justify-space-between\n                mt-4\n                align-center\n              ",
                                  },
                                  [
                                    _vm.Data["ess_att_attendance_master"]
                                      ? _c(
                                          "div",
                                          [
                                            Number(
                                              _vm.Data[
                                                "ess_att_attendance_master"
                                              ]["is_late"]
                                            )
                                              ? _c(
                                                  "v-chip",
                                                  {
                                                    staticClass:
                                                      "ma-1 white--text",
                                                    attrs: {
                                                      small: "",
                                                      color: _vm.$getTagColors(
                                                        _vm.$card_line_colors,
                                                        "is_late_1"
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "label_essweb_system_tag_label_lateLabel"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            Number(
                                              _vm.Data[
                                                "ess_att_attendance_master"
                                              ]["is_ot"]
                                            )
                                              ? _c(
                                                  "v-chip",
                                                  {
                                                    staticClass:
                                                      "ma-1 white--text",
                                                    attrs: {
                                                      small: "",
                                                      color: _vm.$getTagColors(
                                                        _vm.$card_line_colors,
                                                        "is_ot_1"
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "label_essweb_system_tag_label_otLabel"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            Number(
                                              _vm.Data[
                                                "ess_att_attendance_master"
                                              ]["is_missing_punch"]
                                            )
                                              ? _c(
                                                  "v-chip",
                                                  {
                                                    staticClass:
                                                      "ma-1 white--text",
                                                    attrs: {
                                                      small: "",
                                                      color: _vm.$getTagColors(
                                                        _vm.$card_line_colors,
                                                        "is_missing_punch_1"
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "label_essweb_system_tag_label_isMissingPunchLabel"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            Number(
                                              _vm.Data[
                                                "ess_att_attendance_master"
                                              ]["is_adhoc"]
                                            )
                                              ? _c(
                                                  "v-chip",
                                                  {
                                                    staticClass:
                                                      "ma-1 text--primary",
                                                    attrs: {
                                                      small: "",
                                                      color: _vm.$getTagColors(
                                                        _vm.$card_line_colors,
                                                        "is_adhoc_1"
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "label_essweb_system_tag_label_isAdhocLabel"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            Number(
                                              _vm.Data[
                                                "ess_att_attendance_master"
                                              ]["is_on_leave"]
                                            )
                                              ? _vm._l(
                                                  _vm.Data[
                                                    "ess_att_attendance_master"
                                                  ]["leave_info"],
                                                  function (leave, index) {
                                                    return _c(
                                                      "v-chip",
                                                      {
                                                        key: "leave--" + index,
                                                        staticClass: "ma-1",
                                                        attrs: {
                                                          small: "",
                                                          outlined: "",
                                                          color:
                                                            leave.color_code,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$getCommonLangValue(
                                                              leave[
                                                                "leave_type_name"
                                                              ]
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                )
                                              : _vm._e(),
                                            Number(
                                              _vm.Data[
                                                "ess_att_attendance_master"
                                              ]["holiday_info"]
                                            )
                                              ? _vm._l(
                                                  _vm.Data[
                                                    "ess_att_attendance_master"
                                                  ]["holiday_info"],
                                                  function (holiday, index) {
                                                    return _c(
                                                      "v-chip",
                                                      {
                                                        key:
                                                          "holiday--" + index,
                                                        staticClass:
                                                          "ma-1 text--primary",
                                                        attrs: {
                                                          small: "",
                                                          color:
                                                            _vm.$getTagColors(
                                                              _vm.$card_line_colors,
                                                              "is_holiday_1"
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$getCommonLangValue(
                                                              holiday[
                                                                "holiday_name"
                                                              ]
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                )
                                              : _vm._e(),
                                            Number(
                                              _vm.Data[
                                                "ess_att_attendance_master"
                                              ]["is_onDuty"]
                                            )
                                              ? _c(
                                                  "v-chip",
                                                  {
                                                    staticClass:
                                                      "ma-1 white--text",
                                                    attrs: {
                                                      small: "",
                                                      color: _vm.$getTagColors(
                                                        _vm.$card_line_colors,
                                                        "is_on_duty_1"
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "label_essweb_system_tag_label_isOnDutyLabel"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            Number(
                                              _vm.Data[
                                                "ess_att_attendance_master"
                                              ]["is_early_leave"]
                                            )
                                              ? _c(
                                                  "v-chip",
                                                  {
                                                    staticClass:
                                                      "ma-1 white--text",
                                                    attrs: {
                                                      small: "",
                                                      color: _vm.$getTagColors(
                                                        _vm.$card_line_colors,
                                                        "is_early_leave_1"
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "label_essweb_system_tag_label_earlyLeaveLabel"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            Number(
                                              _vm.Data[
                                                "ess_att_attendance_master"
                                              ]["is_absense"]
                                            )
                                              ? _c(
                                                  "v-chip",
                                                  {
                                                    staticClass:
                                                      "ma-1 white--text",
                                                    attrs: {
                                                      small: "",
                                                      color: _vm.$getTagColors(
                                                        _vm.$card_line_colors,
                                                        "is_absense_1"
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "label_essweb_system_tag_label_absenseLabel"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            Number(
                                              _vm.Data[
                                                "ess_att_attendance_master"
                                              ]["is_work_from_home"]
                                            )
                                              ? _c(
                                                  "v-chip",
                                                  {
                                                    staticClass:
                                                      "ma-1 text--primary",
                                                    attrs: {
                                                      small: "",
                                                      color: _vm.$getTagColors(
                                                        _vm.$card_line_colors,
                                                        "is_work_from_home_1"
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "label_essweb_punchRecord_list_tag_workFromHomeLabbel"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            Number(
                                              _vm.Data[
                                                "ess_att_attendance_master"
                                              ]["is_out_of_office"]
                                            )
                                              ? _c(
                                                  "v-chip",
                                                  {
                                                    staticClass:
                                                      "ma-1 text--primary",
                                                    attrs: {
                                                      small: "",
                                                      color: _vm.$getTagColors(
                                                        _vm.$card_line_colors,
                                                        "is_out_of_office_1"
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "label_essweb_system_tag_label_isOutOfOfficeLabel"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                    Number(
                                      _vm.Data["ess_att_attendance_master"][
                                        "is_locked"
                                      ]
                                    )
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              icon: "",
                                              color: _vm.$getTagColors(
                                                _vm.$card_line_colors,
                                                "is_locked_1"
                                              ),
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "material-icons-round",
                                              },
                                              [_vm._v("lock")]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-sheet",
                                  {
                                    staticClass: "rounded-xl px-3 mt-4",
                                    staticStyle: { overflow: "hidden" },
                                    attrs: { elevation: "1" },
                                  },
                                  [
                                    _c(
                                      "v-sheet",
                                      {
                                        staticClass:
                                          "d-flex flex-row justify-space-between",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "text-center",
                                            staticStyle: { width: "24px" },
                                          },
                                          [
                                            _c("svg-icon", {
                                              attrs: {
                                                size: "24",
                                                fill: _vm.Data[
                                                  "ess_att_attendance_master"
                                                ]["official_shift_color_code"],
                                                iconClass: "LabeledColour",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "pl-1",
                                            staticStyle: { "max-width": "40%" },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    _vm.Data[
                                                      "ess_att_attendance_master"
                                                    ]["official_shift_name"]
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                        _c("v-spacer"),
                                        _c(
                                          "div",
                                          { staticClass: "text--secondary" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getDateTime(
                                                    _vm.Data[
                                                      "ess_att_attendance_master"
                                                    ][
                                                      "official_start_utc_time"
                                                    ],
                                                    "HH:mm"
                                                  ) +
                                                    " - " +
                                                    _vm.$getDateTime(
                                                      _vm.Data[
                                                        "ess_att_attendance_master"
                                                      ][
                                                        "official_end_utc_time"
                                                      ],
                                                      "HH:mm"
                                                    )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm.Data["ess_att_attendance_master"][
                                      "site_name"
                                    ]
                                      ? _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "d-flex flex-row justify-start",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "text-center",
                                                staticStyle: { width: "24px" },
                                              },
                                              [
                                                _c("svg-icon", {
                                                  attrs: {
                                                    size: "16",
                                                    fill: "grey",
                                                    iconClass: "site",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "pl-1 text--secondary",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$getCommonLangValue(
                                                        _vm.Data[
                                                          "ess_att_attendance_master"
                                                        ]["site_name"]
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.Data["ess_att_attendance_master"][
                                      "cost_center_name"
                                    ]
                                      ? _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "d-flex flex-row justify-start",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "text-center",
                                                staticStyle: { width: "24px" },
                                              },
                                              [
                                                _c("svg-icon", {
                                                  attrs: {
                                                    size: "16",
                                                    fill: "grey",
                                                    iconClass: "cost_center",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "pl-1 text--secondary",
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$getCommonLangValue(
                                                        _vm.Data[
                                                          "ess_att_attendance_master"
                                                        ]["cost_center_name"]
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "v-sheet",
                                      {
                                        staticClass:
                                          "d-flex flex-row justify-start",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "text-center",
                                            staticStyle: { width: "24px" },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "material-icons-round text--secondary md-16",
                                              },
                                              [_vm._v("event")]
                                            ),
                                          ]
                                        ),
                                        _c("div", { staticClass: "pl-1" }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$getCommonLangValue(
                                                  _vm.Data[
                                                    "ess_att_attendance_master"
                                                  ]["leave_type_remark_name"]
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm.Data["ess_att_attendance_master"][
                                      "remarks"
                                    ]
                                      ? _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "d-flex flex-row justify-start",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-center flex-shrink-1",
                                                staticStyle: { width: "24px" },
                                              },
                                              [
                                                _c("svg-icon", {
                                                  attrs: {
                                                    size: "16",
                                                    fill: "rgba(0, 0, 0, 0.54)",
                                                    iconClass: "mini_doc",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "pl-1 text--secondary text-ellipsis-2",
                                                staticStyle: {
                                                  width: "calc(100% - 24px)",
                                                },
                                                attrs: {
                                                  title:
                                                    _vm.Data[
                                                      "ess_att_attendance_master"
                                                    ]["remarks"],
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.Data[
                                                        "ess_att_attendance_master"
                                                      ]["remarks"]
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-sheet",
                                  {
                                    staticClass:
                                      "rounded-xl d-flex mt-4 flex-column flex-grow-1",
                                    attrs: { elevation: "1" },
                                  },
                                  _vm._l(
                                    _vm.Data["ess_att_attendance_master"][
                                      "ess_att_attendance_detail"
                                    ],
                                    function (item, index) {
                                      return _c(
                                        "v-sheet",
                                        {
                                          key: "detail" + index,
                                          staticClass: "ma-4",
                                        },
                                        [
                                          _c(
                                            "v-sheet",
                                            {
                                              staticClass: "text-subtitle-1",
                                              staticStyle: { width: "100%" },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    item.event_type_name
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "v-sheet",
                                            {
                                              staticClass:
                                                "d-flex flex-row justify-start mt-2",
                                            },
                                            [
                                              _c("v-sheet", {
                                                attrs: {
                                                  width: "8",
                                                  height: "auto",
                                                  color:
                                                    "primary lighten-4 rounded-xl mr-2",
                                                },
                                              }),
                                              _c("v-sheet", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-subtitle-2 text--secondary",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "label_essweb_attendanceModifiApp_form_scheduleShiftTimeLabel"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-subtitle-2",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$getDateTime(
                                                            item.schedule_start_utc_time,
                                                            "HH:mm"
                                                          ) +
                                                            " - " +
                                                            _vm.$getDateTime(
                                                              item.schedule_end_utc_time,
                                                              "HH:mm"
                                                            )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-sheet",
                                            {
                                              staticClass:
                                                "d-flex flex-row justify-start mt-2",
                                            },
                                            [
                                              _c("v-sheet", {
                                                attrs: {
                                                  width: "8",
                                                  height: "auto",
                                                  color:
                                                    "primary lighten-2 rounded-xl mr-2",
                                                },
                                              }),
                                              _c("v-sheet", [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-subtitle-2 text--secondary",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "label_essweb_attendanceModifiApp_form_officialShiftTimeLabel"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "text-subtitle-2",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$getDateTime(
                                                            item.official_start_utc_time,
                                                            "HH:mm"
                                                          ) +
                                                            " - " +
                                                            _vm.$getDateTime(
                                                              item.official_end_utc_time,
                                                              "HH:mm"
                                                            )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-sheet",
                                            {
                                              staticClass:
                                                "d-flex flex-row justify-start mt-2",
                                            },
                                            [
                                              _c("v-sheet", {
                                                attrs: {
                                                  width: "8",
                                                  height: "auto",
                                                  color:
                                                    "primary base rounded-xl mr-2",
                                                },
                                              }),
                                              _c(
                                                "v-sheet",
                                                { attrs: { width: "100%" } },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-subtitle-2 text--secondary",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "label_essweb_attendanceModifiApp_form_actualPunchTime"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "\n                        d-flex\n                        flex-row\n                        justify-space-between\n                        flex-grow-1\n                        mt-2\n                      ",
                                                      staticStyle: {
                                                        width: "100%",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-sheet",
                                                        {
                                                          attrs: {
                                                            color:
                                                              "transparent text-subtitle-2 text-center rounded",
                                                            width: "50%",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$getDateTime(
                                                                  item.actual_punch_in_utc_datetime,
                                                                  "HH:mm"
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "text-center",
                                                          staticStyle: {
                                                            width: "20px",
                                                          },
                                                        },
                                                        [_vm._v("-")]
                                                      ),
                                                      _c(
                                                        "v-sheet",
                                                        {
                                                          attrs: {
                                                            color:
                                                              "transparent text-subtitle-2 text-center rounded",
                                                            width: "50%",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$getDateTime(
                                                                  item.actual_punch_out_utc_datetime,
                                                                  "HH:mm"
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-sheet",
                                            {
                                              staticClass:
                                                "d-flex flex-row justify-start mt-2",
                                            },
                                            [
                                              _c("v-sheet", {
                                                attrs: {
                                                  width: "8",
                                                  height: "auto",
                                                  color:
                                                    "primary rounded-xl mr-2",
                                                },
                                              }),
                                              _c(
                                                "v-sheet",
                                                { attrs: { width: "100%" } },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-subtitle-2 text--secondary",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "label_essweb_attendanceModifiApp_form_officialPunchTime"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "\n                        d-flex\n                        flex-row\n                        justify-space-between\n                        flex-grow-1\n                        mt-2\n                      ",
                                                      staticStyle: {
                                                        width: "100%",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-sheet",
                                                        {
                                                          attrs: {
                                                            color:
                                                              "transparent text-subtitle-2 text-center rounded",
                                                            width: "50%",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$getDateTime(
                                                                  item.official_punch_in_utc_datetime,
                                                                  "HH:mm"
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "text-center",
                                                          staticStyle: {
                                                            width: "20px",
                                                          },
                                                        },
                                                        [_vm._v("-")]
                                                      ),
                                                      _c(
                                                        "v-sheet",
                                                        {
                                                          attrs: {
                                                            color:
                                                              "transparent text-subtitle-2 text-center rounded",
                                                            width: "50%",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$getDateTime(
                                                                  item.official_punch_out_utc_datetime,
                                                                  "HH:mm"
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  false
                                                    ? _c(
                                                        "div",
                                                        { staticClass: "mt-2" },
                                                        [
                                                          _c(
                                                            "v-chip",
                                                            {
                                                              attrs: {
                                                                small: "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "label_essweb_attendanceModifiApp_form_totalLabel"
                                                                    )
                                                                  ) +
                                                                  "(" +
                                                                  _vm._s(
                                                                    _vm.$timeMachine(
                                                                      item.total_minutes,
                                                                      false
                                                                    )
                                                                  ) +
                                                                  ") "
                                                              ),
                                                            ]
                                                          ),
                                                          Number(
                                                            item.late_minutes
                                                          ) > 0
                                                            ? _c(
                                                                "v-chip",
                                                                {
                                                                  attrs: {
                                                                    small: "",
                                                                    color:
                                                                      "red",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "label_essweb_attendanceModifiApp_form_lateLabel"
                                                                        )
                                                                      ) +
                                                                      "(" +
                                                                      _vm._s(
                                                                        _vm.$timeMachine(
                                                                          item.late_minutes,
                                                                          false
                                                                        )
                                                                      ) +
                                                                      ") "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          Number(
                                                            item.early_leave_minutes
                                                          ) > 0
                                                            ? _c(
                                                                "v-chip",
                                                                {
                                                                  attrs: {
                                                                    small: "",
                                                                    color:
                                                                      "red",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "label_essweb_attendanceModifiApp_form_earlyLeaveLabel"
                                                                        )
                                                                      ) +
                                                                      "(" +
                                                                      _vm._s(
                                                                        _vm.$timeMachine(
                                                                          item.early_leave_minutes,
                                                                          false
                                                                        )
                                                                      ) +
                                                                      ") "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          Number(
                                                            item.ot_minutes_before
                                                          ) +
                                                          Number(
                                                            item.ot_minutes_after
                                                          )
                                                            ? _c(
                                                                "v-chip",
                                                                {
                                                                  attrs: {
                                                                    small: "",
                                                                    color:
                                                                      "primary",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "label_essweb_attendanceModifiApp_form_otLabel"
                                                                        )
                                                                      ) +
                                                                      "(" +
                                                                      _vm._s(
                                                                        _vm.$timeMachine(
                                                                          Number(
                                                                            item.ot_minutes_before
                                                                          ) +
                                                                            Number(
                                                                              item.ot_minutes_after
                                                                            ),
                                                                          false
                                                                        )
                                                                      ) +
                                                                      ") "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-sheet",
                              {
                                staticClass:
                                  "\n              mt-6\n              align-center\n              text-center\n              align-items-center\n              text--primary\n              rounded-r-lg\n              d-flex\n              flex-column\n              title\n            ",
                                staticStyle: { cursor: "pointer" },
                                attrs: {
                                  width: "30",
                                  height: "60",
                                  elevation: 2,
                                  color: "white",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.slideOpen = !_vm.slideOpen
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "material-icons-round ma-auto",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.slideOpen
                                          ? "arrow_left"
                                          : "arrow_right"
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-sheet",
                          {
                            staticClass: "pa-1 rounded-lg panel_right",
                            attrs: {
                              width: _vm.showTab ? 350 : 100,
                              height: !_vm.showTab ? 40 : undefined,
                              elevation: "1",
                            },
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                staticStyle: {
                                  position: "absolute",
                                  right: "5px",
                                  "z-index": "10",
                                  "margin-top": "0px",
                                },
                                attrs: { icon: "" },
                                on: {
                                  click: function ($event) {
                                    _vm.showTab = !_vm.showTab
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "material-icons-round" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.showTab
                                          ? "keyboard_arrow_up"
                                          : "keyboard_arrow_down"
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.showTab,
                                    expression: "!showTab",
                                  },
                                ],
                                staticClass:
                                  "material-icons-round text--secondary",
                                staticStyle: {
                                  position: "absolute",
                                  right: "60px",
                                  "z-index": "10",
                                  "margin-top": "5px",
                                },
                              },
                              [_vm._v("bar_chart")]
                            ),
                            _vm.showTab
                              ? _c("Taber", {
                                  attrs: {
                                    curTab: _vm.curTab,
                                    items: _vm.taber,
                                    height: 40,
                                    special: "",
                                    backgroundColor: "white",
                                    centered: false,
                                    showTab: _vm.showTab,
                                    grow: false,
                                  },
                                  on: {
                                    change: function (tab) {
                                      return (_vm.curTab = tab)
                                    },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "content-1",
                                        fn: function () {
                                          return [
                                            _c("div", { staticClass: "px-3" }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex flex-row",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-subtitle-2 text--primary",
                                                      staticStyle: {
                                                        width: "50%",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "label_essweb_attendanceModifiApp_form_totalWorkingLabel"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-center flex-grow-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$timeMachine(
                                                              _vm.Data[
                                                                "ess_att_attendance_master"
                                                              ][
                                                                "official_working_minutes"
                                                              ] || 0,
                                                              false
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex flex-row",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-subtitle-2 text--primary",
                                                      staticStyle: {
                                                        width: "50%",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "label_essweb_attendanceModifiApp_form_totalBreakMinutesLabel"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-center flex-grow-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$timeMachine(
                                                              _vm.Data[
                                                                "ess_att_attendance_master"
                                                              ][
                                                                "official_break_minutes"
                                                              ] || 0,
                                                              false
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex flex-row",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-subtitle-2 text--primary",
                                                      staticStyle: {
                                                        width: "50%",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "label_essweb_attendanceModifiApp_form_totalMealMinutes"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-center flex-grow-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$timeMachine(
                                                              _vm.Data[
                                                                "ess_att_attendance_master"
                                                              ][
                                                                "official_meal_minutes"
                                                              ] || 0,
                                                              false
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex flex-row",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-subtitle-2 text--primary",
                                                      staticStyle: {
                                                        width: "50%",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "label_essweb_attendanceModifiApp_form_totalOTLabel"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-center flex-grow-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$timeMachine(
                                                              _vm.Data[
                                                                "ess_att_attendance_master"
                                                              ][
                                                                "official_total_ot_minutes"
                                                              ] || 0,
                                                              false
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex flex-row",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-subtitle-2 text--primary",
                                                      staticStyle: {
                                                        width: "50%",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "label_essweb_attendanceModifiApp_form_totalLateLabel"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-center flex-grow-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$timeMachine(
                                                              _vm.Data[
                                                                "ess_att_attendance_master"
                                                              ][
                                                                "official_total_late_minutes"
                                                              ] || 0,
                                                              false
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex flex-row",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-subtitle-2 text--primary",
                                                      staticStyle: {
                                                        width: "50%",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "label_essweb_attendanceModifiApp_form_totalEarlyLeaveLabel"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-center flex-grow-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$timeMachine(
                                                              _vm.Data[
                                                                "ess_att_attendance_master"
                                                              ][
                                                                "official_total_early_leave_minutes"
                                                              ] || 0,
                                                              false
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex flex-row",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-subtitle-2 text--primary",
                                                      staticStyle: {
                                                        width: "50%",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "label_essweb_attendanceModifiApp_form_totalLeaveLabel"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-center flex-grow-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$timeMachine(
                                                              _vm.Data[
                                                                "ess_att_attendance_master"
                                                              ][
                                                                "official_total_leave_minutes"
                                                              ] || 0,
                                                              false
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex flex-row",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-subtitle-2 text--primary",
                                                      staticStyle: {
                                                        width: "50%",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "label_essweb_attendanceModifiApp_form_totalAbsenseLabel"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-center flex-grow-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$timeMachine(
                                                              _vm.Data[
                                                                "ess_att_attendance_master"
                                                              ][
                                                                "official_absense_minutes"
                                                              ] || 0,
                                                              false
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex flex-row",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-subtitle-2 text--primary",
                                                      staticStyle: {
                                                        width: "50%",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "label_essweb_attendanceModifiApp_form_totalBeforeWorkLabel"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-center flex-grow-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$timeMachine(
                                                              _vm.Data[
                                                                "ess_att_attendance_master"
                                                              ][
                                                                "official_before_work_minutes"
                                                              ] || 0,
                                                              false
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex flex-row",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-subtitle-2 text--primary",
                                                      staticStyle: {
                                                        width: "50%",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "label_essweb_attendanceModifiApp_form_totalAfterWorkLabel"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-center flex-grow-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$timeMachine(
                                                              _vm.Data[
                                                                "ess_att_attendance_master"
                                                              ][
                                                                "official_after_work_minutes"
                                                              ] || 0,
                                                              false
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                      {
                                        key: "content-2",
                                        fn: function () {
                                          return [
                                            _c("div", { staticClass: "px-3" }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex flex-row",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-subtitle-2 text--primary",
                                                      staticStyle: {
                                                        width: "50%",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "label_essweb_attendanceModifiApp_form_totalWorkingLabel"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-center flex-grow-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$timeMachine(
                                                              _vm.Data[
                                                                "ess_att_attendance_master"
                                                              ][
                                                                "actual_working_minutes"
                                                              ] || 0,
                                                              false
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex flex-row",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-subtitle-2 text--primary",
                                                      staticStyle: {
                                                        width: "50%",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "label_essweb_attendanceModifiApp_form_totalBreakMinutesLabel"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-center flex-grow-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$timeMachine(
                                                              _vm.Data[
                                                                "ess_att_attendance_master"
                                                              ][
                                                                "actual_break_minutes"
                                                              ] || 0,
                                                              false
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex flex-row",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-subtitle-2 text--primary",
                                                      staticStyle: {
                                                        width: "50%",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "label_essweb_attendanceModifiApp_form_totalMealMinutes"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-center flex-grow-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$timeMachine(
                                                              _vm.Data[
                                                                "ess_att_attendance_master"
                                                              ][
                                                                "actual_meal_minutes"
                                                              ] || 0,
                                                              false
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex flex-row",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-subtitle-2 text--primary",
                                                      staticStyle: {
                                                        width: "50%",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "label_essweb_attendanceModifiApp_form_totalOTLabel"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-center flex-grow-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$timeMachine(
                                                              _vm.Data[
                                                                "ess_att_attendance_master"
                                                              ][
                                                                "actual_ot_minutes"
                                                              ] || 0,
                                                              false
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex flex-row",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-subtitle-2 text--primary",
                                                      staticStyle: {
                                                        width: "50%",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "label_essweb_attendanceModifiApp_form_totalLateLabel"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-center flex-grow-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$timeMachine(
                                                              _vm.Data[
                                                                "ess_att_attendance_master"
                                                              ][
                                                                "actual_late_minutes"
                                                              ] || 0,
                                                              false
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex flex-row",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-subtitle-2 text--primary",
                                                      staticStyle: {
                                                        width: "50%",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "label_essweb_attendanceModifiApp_form_totalEarlyLeaveLabel"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-center flex-grow-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$timeMachine(
                                                              _vm.Data[
                                                                "ess_att_attendance_master"
                                                              ][
                                                                "actual_early_leave_minutes"
                                                              ] || 0,
                                                              false
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex flex-row",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-subtitle-2 text--primary",
                                                      staticStyle: {
                                                        width: "50%",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "label_essweb_attendanceModifiApp_form_totalLeaveLabel"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-center flex-grow-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$timeMachine(
                                                              _vm.Data[
                                                                "ess_att_attendance_master"
                                                              ][
                                                                "actual_leave_minutes"
                                                              ] || 0,
                                                              false
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex flex-row",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-subtitle-2 text--primary",
                                                      staticStyle: {
                                                        width: "50%",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "label_essweb_attendanceModifiApp_form_totalAbsenseLabel"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-center flex-grow-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$timeMachine(
                                                              _vm.Data[
                                                                "ess_att_attendance_master"
                                                              ][
                                                                "actual_absense_minutes"
                                                              ] || 0,
                                                              false
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex flex-row",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-subtitle-2 text--primary",
                                                      staticStyle: {
                                                        width: "50%",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "label_essweb_attendanceModifiApp_form_totalBeforeWorkLabel"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-center flex-grow-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$timeMachine(
                                                              _vm.Data[
                                                                "ess_att_attendance_master"
                                                              ][
                                                                "actual_before_work_minutes"
                                                              ] || 0,
                                                              false
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "d-flex flex-row",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-subtitle-2 text--primary",
                                                      staticStyle: {
                                                        width: "50%",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "label_essweb_attendanceModifiApp_form_totalAfterWorkLabel"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "text-center flex-grow-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$timeMachine(
                                                              _vm.Data[
                                                                "ess_att_attendance_master"
                                                              ][
                                                                "actual_after_work_minutes"
                                                              ] || 0,
                                                              false
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    683747626
                                  ),
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm.showMap && _vm.markers.length > 0
                          ? _c(
                              "GmapMap",
                              {
                                ref: "curmap",
                                staticStyle: { width: "100%", height: "100%" },
                                attrs: {
                                  center: _vm.center,
                                  zoom: 18,
                                  options: {
                                    zoomControl: true,
                                    mapTypeControl: false,
                                    scaleControl: false,
                                    streetViewControl: false,
                                    rotateControl: false,
                                    keyboardShortcuts: false,
                                    gestureHandling: "greedy",
                                    fullscreenControl: false,
                                    disableDefaultUi: false,
                                    controlSize: 22,
                                  },
                                  "map-type-id": "roadmap",
                                },
                              },
                              [
                                _vm._l(_vm.markers, function (m, index) {
                                  return _c("GmapMarker", {
                                    key: index,
                                    attrs: {
                                      option: {
                                        animation: "drop",
                                        shape: "circle",
                                      },
                                      position: m.position,
                                      icon: _vm.makericon,
                                      clickable: true,
                                      draggable: false,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.toggleInfoWindow(m, index)
                                      },
                                    },
                                  })
                                }),
                                _c(
                                  "gmap-info-window",
                                  {
                                    staticClass: "mb-4",
                                    attrs: {
                                      options: {
                                        pixelOffset: {
                                          width: 0,
                                          height: -70,
                                        },
                                      },
                                      position: _vm.infoWindowPos,
                                      opened: _vm.infoWinOpen,
                                    },
                                    on: {
                                      closeclick: function ($event) {
                                        _vm.infoWinOpen = false
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "v-sheet",
                                      {
                                        staticClass: "pl-n3",
                                        attrs: { width: "200" },
                                      },
                                      [
                                        _c(
                                          "v-sheet",
                                          {
                                            staticClass:
                                              "d-flex flex-row justify-start align-center py-3",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "text-center",
                                                staticStyle: { width: "24px" },
                                              },
                                              [
                                                _c("svg-icon", {
                                                  attrs: {
                                                    size: "24",
                                                    fill: _vm.Data[
                                                      "official_shift_color_code"
                                                    ],
                                                    iconClass: "LabeledColour",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "pl-1 d-inline-block text-truncate text-body-1",
                                                staticStyle: {
                                                  "max-width": "80%",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$getCommonLangValue(
                                                        _vm.Data[
                                                          "official_shift_name"
                                                        ]
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._l(
                                          _vm.curRecord,
                                          function (item, index) {
                                            return _c(
                                              "v-sheet",
                                              {
                                                key: "record---" + index,
                                                staticClass:
                                                  "d-flex flex-row justify-start my-2",
                                              },
                                              [
                                                _c("v-sheet", {
                                                  attrs: {
                                                    width: "1",
                                                    height: "auto",
                                                    color: "black   mr-2",
                                                  },
                                                }),
                                                _c(
                                                  "v-sheet",
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "text-subtitle-2 text--secondary py-1",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$getCommonLangValue(
                                                                item.event_type_name
                                                              )
                                                            ) +
                                                            "(" +
                                                            _vm._s(
                                                              item[
                                                                "punch_type"
                                                              ] == 1
                                                                ? _vm.$t(
                                                                    "label_essweb_attendanceRecord_list_inLabel"
                                                                  )
                                                                : item[
                                                                    "punch_type"
                                                                  ] == 2
                                                                ? _vm.$t(
                                                                    "label_essweb_attendanceRecord_list_outLabbel"
                                                                  )
                                                                : ""
                                                            ) +
                                                            ") "
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "v-sheet",
                                                      {
                                                        staticClass:
                                                          "d-flex align-center flex-row justify-start",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "material-icons-round text--secondary",
                                                          },
                                                          [_vm._v(" schedule ")]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "text-subtitle-2 grey lighten-3 px-8 ml-2 rounded",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$getDateTime(
                                                                    item[
                                                                      "punch_type"
                                                                    ] == 1
                                                                      ? item[
                                                                          "actual_punch_in_utc_datetime"
                                                                        ]
                                                                      : item[
                                                                          "punch_type"
                                                                        ] == 2
                                                                      ? item[
                                                                          "actual_punch_out_utc_datetime"
                                                                        ]
                                                                      : "",
                                                                    "HH:mm"
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              2
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.Data
              ? _c(
                  "Section",
                  [
                    _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "6",
                              md: "6",
                              lg: "6",
                              cols: "12",
                            },
                          },
                          [
                            _c("v-sheet", { staticClass: "text--secondary" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "label_essweb_attendanceModifiApp_form_reasonLabel"
                                  )
                                )
                              ),
                            ]),
                            _c("v-text-field", {
                              attrs: {
                                readonly: "",
                                label: _vm.$t(
                                  "label_essweb_attendanceModifiApp_form_reasonLabel"
                                ),
                                "single-line": "",
                                dense: "",
                              },
                              model: {
                                value:
                                  _vm.Data.attendance_modification_reason_text,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.Data,
                                    "attendance_modification_reason_text",
                                    $$v
                                  )
                                },
                                expression:
                                  "Data.attendance_modification_reason_text",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            attrs: {
                              xs: "12",
                              sm: "6",
                              md: "6",
                              lg: "6",
                              cols: "12",
                            },
                          },
                          [
                            _c("v-sheet", { staticClass: "text--secondary" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "label_essweb_attendanceModifiApp_form_messageLabel"
                                  )
                                )
                              ),
                            ]),
                            _c("v-text-field", {
                              attrs: {
                                readonly: "",
                                label: _vm.$t(
                                  "label_essweb_attendanceModifiApp_form_messageLabel"
                                ),
                                "single-line": "",
                                dense: "",
                              },
                              model: {
                                value: _vm.Data.remarks,
                                callback: function ($$v) {
                                  _vm.$set(_vm.Data, "remarks", $$v)
                                },
                                expression: "Data.remarks",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }